import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { extendTailwindMerge } from 'tailwind-merge';
const twMerge = extendTailwindMerge({
    prefix: 'nucleus-',
});
const pillDotColors = {
    neutral: 'nucleus-bg-neutral-450',
    primary: 'nucleus-bg-primary-500',
    success: 'nucleus-bg-green-500',
    warning: 'nucleus-bg-yellow-500',
    danger: 'nucleus-bg-red-500',
};
const pillBaseClasses = 'nucleus-box-border nucleus-font-sans nucleus-inline-flex nucleus-w-fit nucleus-items-center nucleus-gap-2 nucleus-rounded-full nucleus-px-3 nucleus-py-0.5 nucleus-text-sm nucleus-font-medium nucleus-text-text-primary';
const pillFilledClass = 'nucleus-bg-background';
const pillTransparentClass = 'nucleus-bg-transparent';
const pillOutlinedClass = 'nucleus-border nucleus-border-solid nucleus-border-neutral-300';
const pillBorderlessClass = 'nucleus-border-0';
/**
 * Pills display a short status label paired with a colored status dot. Use them to surface the
 * current state of an entity (participant status, activity status, etc.) in a compact form.
 */
export const Pill = (_a) => {
    var { dataTestId, variant = 'neutral', label, outlined = true, filled = true, className } = _a, props = __rest(_a, ["dataTestId", "variant", "label", "outlined", "filled", "className"]);
    return (_jsxs("div", Object.assign({ "data-testid": dataTestId, className: twMerge(pillBaseClasses, filled ? pillFilledClass : pillTransparentClass, outlined ? pillOutlinedClass : pillBorderlessClass, className) }, props, { role: 'status', "aria-label": label, children: [_jsx("span", { "aria-hidden": 'true', "data-testid": dataTestId ? `${dataTestId}-dot` : undefined, className: twMerge('nucleus-h-2 nucleus-w-2 nucleus-shrink-0 nucleus-rounded-full', pillDotColors[variant]) }), _jsx("span", { children: label })] })));
};
//# sourceMappingURL=pill.js.map